const stripHTML = (htmlStr: string): string => {
    return htmlStr.replace(/<\/?[^>]+(>|$)/g, "").toLocaleLowerCase();
}

export default stripHTML;